import { ChevronRight } from "lucide-react";
import type { Metadata } from "@/lib/head";
import { Link } from "@/lib/nav";

import CustomerScreenShell from "@/components/customer-screen-shell";
import { sectionCardClass } from "@buildpy/ui/section-card";
import { cn } from "@/lib/utils";
import { DEMO_CUSTOMER, DEMO_ORG, DEMO_TITLE } from "@buildpy/core/modules/demo/data";
import { DEMO_PATH } from "@buildpy/core/modules/demo/routes";

export const metadata: Metadata = {
  title: "고객 화면 데모",
  description: "인테리어 고객이 받는 견적서·내 현장·현재 내역서를 로그인 없이 둘러보는 데모입니다.",
};

const SCREENS = [
  { href: DEMO_PATH.quote, title: "견적서 (리비전 2)", body: "고객 폰으로 가는 견적 링크 — 공종을 눌러 항목까지 봅니다." },
  { href: DEMO_PATH.project, title: "내 현장", body: "매일 올라오는 사진·현장일지, 승인을 기다리는 변경공사, 담당자와 대화." },
  { href: DEMO_PATH.statement, title: "현재 내역서", body: "승인한 변경공사까지 반영된 지금의 계약 내역." },
] as const;

// 데모 첫 화면 — 가상 현장 소개와 고객 화면 세 개로 가는 길.
const Page = () => (
  <CustomerScreenShell safeTop={false}>
    <div className="mx-auto flex w-full max-w-md flex-col gap-y-4">
      <div className="flex flex-col gap-y-1">
        <p className="text-xs text-muted-foreground">{DEMO_ORG.name} · {DEMO_CUSTOMER.name} 고객님 현장</p>
        <h1 className="text-xl font-semibold">{DEMO_TITLE}</h1>
        <p className="text-sm text-muted-foreground">
          시공사가 buildpy(빌드파이)로 보내면 고객은 앱 설치 없이 아래 화면을 받습니다. 가상의 현장이라 마음껏 눌러 보셔도 됩니다.
        </p>
      </div>
      <ul className="flex flex-col gap-y-2">
        {SCREENS.map((s, i) => (
          <li key={s.href}>
            <Link className={cn(sectionCardClass({ interactive: true }), "flex items-center gap-3")} href={s.href}>
              <span className="flex size-8 shrink-0 items-center justify-center rounded-full bg-accent text-sm font-semibold text-accent-foreground">
                {i + 1}
              </span>
              <span className="min-w-0 flex-1">
                <span className="block font-semibold">{s.title}</span>
                <span className="block text-sm text-muted-foreground">{s.body}</span>
              </span>
              <ChevronRight aria-hidden className="size-4 shrink-0 text-muted-foreground" />
            </Link>
          </li>
        ))}
      </ul>
      <Link className="self-center text-sm text-muted-foreground underline-offset-2 hover:underline" href="/">
        buildpy 소개로 돌아가기
      </Link>
    </div>
  </CustomerScreenShell>
);

export default Page;
